export default __webpack_public_path__ + "static/media/avacado.c741a5c1.png";